import { __extends } from "tslib";
import { AnimationNodeBase } from '@awayjs/renderer';
import { SkeletonDirectionalState } from '../states/SkeletonDirectionalState';
/**
 * A skeleton animation node that uses four directional input poses with an input direction to blend a linearly interpolated output of a skeleton pose.
 */
var SkeletonDirectionalNode = /** @class */ (function (_super) {
    __extends(SkeletonDirectionalNode, _super);
    function SkeletonDirectionalNode() {
        var _this = _super.call(this) || this;
        _this._pStateClass = SkeletonDirectionalState;
        return _this;
    }
    /**
     * @inheritDoc
     */
    SkeletonDirectionalNode.prototype.getAnimationState = function (animator) {
        return animator.getAnimationState(this);
    };
    return SkeletonDirectionalNode;
}(AnimationNodeBase));
export { SkeletonDirectionalNode };
